export const columnsRFNumber = [
  {
    dataIndex: 'OrderQuotation',
    title: 'Order Quotation',
    key: 'OrderQuotation',
  },
  {
    dataIndex: 'OrderDate',
    title: 'Order Date',
    key: 'OrderDate',
  },
  {
    dataIndex: 'RFNumber',
    title: 'RF Number',
    key: 'RFNumber',
  },
  {
    dataIndex: 'ReportNumber',
    title: 'Report Number',
    key: 'ReportNumber',
    render: (value) => value ? value : '-'
  },
  {
    dataIndex: 'SalesName',
    title: 'Sales Name',
    key: 'SalesName',
  },
  {
    dataIndex: 'CustomerName',
    title: 'Customer Name',
    key: 'CustomerName',
  },
  {
    dataIndex: 'Department',
    title: 'Department',
    key: 'Department',
  },
  // {
  //   dataIndex: 'MaxTAT',
  //   title: 'Max TAT',
  //   key: 'MaxTAT',
  // },
]

export const columnsSample = [
  {
    dataIndex: 'SampleNumber',
    title: 'Sample Number',
    key: 'SampleNumber',
  },
  {
    dataIndex: 'SampleName',
    title: 'Sample Name',
    key: 'SampleName',
  },
  {
    dataIndex: 'ServiceType',
    title: 'Service Type',
    key: 'ServiceType',
    render: (value) => value ? value : '-'
  },
  {
    dataIndex: 'ReportNumber',
    title: 'Report Number',
    key: 'ReportNumber',
  },
  {
    dataIndex: 'ParameterName',
    title: 'Parameter Name',
    key: 'ParameterName',
  }
];

export const columnsCustomer = [
  // {
  //   dataIndex: "AccountId",
  //   title: "Account Id",
  //   key: "Account Id",
  // },
  {
    dataIndex: "CustomerId",
    title: "Customer Id",
    key: "CustomerId",
  },
  {
    dataIndex: "CustomerName",
    title: "Customer Name",
    key: "CustomerName",
  },
  {
    dataIndex: "ContactPerson",
    title: "Contact Person",
    key: "ContactPerson",
  },
  {
    dataIndex: "Address",
    title: "Address",
    key: "Address",
  },
  {
    dataIndex: "EmailContact",
    title: "Email Contact",
    key: "EmailContact",
  },
  {
    dataIndex: "Phone",
    title: "Phone",
    key: "Phone",
  },
  {
    dataIndex: "MobilePhone",
    title: "Mobile Phone",
    key: "MobilePhone",
  },
  {
    dataIndex: "Fax",
    title: "Fax",
    key: "Fax",
  },
];